<template lang="pug">
  main.main-layout
    main-header
    div.main-content
      router-view
    main-footer
    loader
    notifications(group='general', position='bottom right')
</template>

<script>
import mainHeader from '../components/common/main-header.vue'
import mainFooter from '../components/common/main-footer.vue'
import loader from '../components/common/loader.vue'

export default {
  components: {
    mainHeader, mainFooter, loader
  },
  data () {
    return {}
  },
  async mounted () {
    const profileCheckFunction = async () => {
      this.$store.dispatch('startTask', { id: 'fetch-profile' })
      const timeout = setTimeout(() => {
        this.$store.dispatch('clearTasks')
      }, 3000)
      try {
        await this.$store.dispatch('quote/fetchProfile')
        this.$store.dispatch('endTask', { id: 'fetch-profile' })
        const profile = this.$store.getters['quote/profile']
        clearTimeout(timeout)
        if ((!profile.firstname || !profile.lastname || !profile.company || !profile.phone || !profile.address || !profile.city || !profile.zipCode) &&
          !window.location.pathname.includes('complete-profile')) {
          this.$router.push('/complete-profile')
        }
      } catch (error) {
        this.$store.dispatch('clearTasks')
        this.$notify({ group: 'general', type: error.type || 'error', title: error.title, text: error.message, duration: -1 })
      }
    }
    if (this.$store.state.auth.accessToken) {
      profileCheckFunction()
    } else {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'auth/setAccessToken') {
          setTimeout(() => {
            profileCheckFunction()
          }, 100)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';

  main {
    display: flex;
    min-height: 100%;
    height: 100%;
    flex-direction: column;
  }

  .main-content {
    display: flex;
    background: $almost-white;
    padding-bottom: 3em;
    flex: 1 0 auto;
    align-items: center;
    justify-items: center;
  }
</style>
